export default class AutocompleteCities {
    constructor() {
        this.cityBillingField = document.querySelector("#billing_city_field");
        this.cityShippingField = document.querySelector("#shipping_city_field");

        if (this.cityBillingField || this.cityShippingField) {
            this.cityBillingField.insertAdjacentHTML(
                "beforeend",
                '<div id="result_billing_city" class="woocommerce-input-wrapper-results" style="display: none;"><p class="woocommerce-input-wrapper-results-city"></p></div>'
            );
            this.cityShippingField.insertAdjacentHTML(
                "beforeend",
                '<div id="result_shipping_city" class="woocommerce-input-wrapper-results" style="display: none;"><p class="woocommerce-input-wrapper-results-city"></p></div>'
            );

            this.timeout = null;
            this.events();
        }
    }

    events() {
        // this.cityBillingField.addEventListener("change", (e) => {
        //     this.checkFieldCities(e);
        // });
        this.cityBillingField.addEventListener("keyup", (e) => {
            this.checkFieldCities(e);
        });
        this.cityBillingField.addEventListener("focus", (e) => {
            this.checkFieldCities(e);
        });
        // this.cityShippingField.addEventListener("change", (e) => {
        //     this.checkFieldCities(e);
        // });
        this.cityShippingField.addEventListener("keyup", (e) => {
            this.checkFieldCities(e);
        });
        this.cityShippingField.addEventListener("focus", (e) => {
            this.checkFieldCities(e);
        });

        document.addEventListener("click", function (e) {
            if (
                e.target &&
                e.target.className === "woocommerce-input-wrapper-results-city"
            ) {
                const results = e.target.dataset.results;
                const input = e.target.dataset.input;
                const loader = document.getElementById("resultsSvgJs");

                document.getElementById(input).value = e.target.dataset.city;

                document.getElementById(results).innerHTML = "";
                document.getElementById(results).style.display = "none";

                if (loader) {
                    loader.remove();
                }
            }
        });
    }

    checkFieldCities(field) {
        const self = this;

        if (self.timeout !== undefined) {
            clearTimeout(self.timeout);
        }

        self.timeout = setTimeout(() => {
            self.fieldCities(field);
        }, 500);
    }

    fieldCities(field) {
        const fieldValue = field.target;
        const nameValue = "result_" + field.target.id;
        const nameField = field.target.id + "_field";
        const autocompleteResult = document.getElementById(nameValue);

        if (fieldValue.value.length < 3) {
            return;
        }

        document
            .querySelector("#" + nameField)
            .insertAdjacentHTML(
                "beforeend",
                '<svg class="woocommerce-input-wrapper-results-loader" id="resultsSvgJs" version="1.1" class="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"width="32" height="32" viewBox="0 0 128 128" xml:space="preserve"><g><circle cx="64" cy="64" r="32" stroke="#e5e5e5" fill="transparent" stroke-dasharray="200" stroke-linecap="round" stroke-width="6"><animateTransform attributeType="xml"attributeName="transform"type="rotate"dur="1.5s"values="-90 64 64;-90 64 64;200 64 64;270 64 64"repeatCount="indefinite"/><animate attributeType="xml"attributeName="stroke-dashoffset"dur="1.5s"values="180;30;180;180"repeatCount="indefinite"/></circle><animateTransform attributeType="xml"attributeName="transform"type="rotate"dur="3s"values="0 64 64;360 64 64"repeatCount="indefinite"/></g></svg>'
            );

        fetch(window.global.ajax_url + "?action=getCities", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                input: fieldValue.value,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    const dataCities = data.data;
                    const fragment = document.createDocumentFragment();

                    dataCities.forEach(function (obj) {
                        const city = document.createElement("p");
                        city.className =
                            "woocommerce-input-wrapper-results-city";
                        city.innerText = obj;
                        city.dataset.input = field.target.id;
                        city.dataset.results = nameValue;
                        city.dataset.city = obj;
                        fragment.appendChild(city);
                    });

                    autocompleteResult.innerHTML = "";
                    autocompleteResult.appendChild(fragment);
                    autocompleteResult.style.display = "block";
                    document.getElementById("resultsSvgJs").remove();
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
